export default "__VITE_ASSET__05afc2fb__"